import { computed, observable } from 'mobx';
import Abstract from './abstract';
import { CONTENT_EDITING, CONTENT_NEW } from 'common/constant';
import { authentication } from '@/packages/content/view/businessContent/helper/authentication';
import { getCatalogName } from 'common/help/get-catalog-name';

export class Content extends Abstract {
  @observable public current;
  @observable public info;
  @observable public setting;
  // Request URL: /api/v1/businesses_english/collection?businessConfigUuid=AI_INTERACTIVE_CLASS&courseUuid=xx
  @observable public collection;

  @computed get status() {
    return nx.get(this.current, 'status');
  }

  @computed get canEdit() {
    return [CONTENT_EDITING, CONTENT_NEW].includes(this.status) && authentication('edit');
  }

  @computed
  get type() {
    const { businessConfigUuid } = nx.hashlize();
    return businessConfigUuid;
  }

  @computed
  get isMixedCourseware() {
    return this.type === 'MIXED_COURSEWARE';
  }

  @computed
  get catalogName() {
    const items = nx.get(this.collection, 'courseCatalogueResponses', []);
    return getCatalogName(items);
  }
}
